import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { MotorSportRowWrapper, RaceViewCircuit, Circuit } from './styles';
import { prettyMatchUrl } from '../../common/rcs_gaz_mc_core_FE';
import ConfigManager from '../../common/configManager/configManager';
import Label from '../../components/shared/Label';
import IconFont from '../../components/shared/IconFont';
import * as st from '../../constants';

const MotorSportRow = ({ grandPrixRow, dictionary, isMobile }) => {
  const isOtherPhase = trSt => trSt === st.ABORTED || trSt === st.TOAPPROVAL || trSt === st.TBD;

  const formatDate = (datePassed) => {
    const dateJs = new Date(datePassed);
    const month = (`0${Number(dateJs.getMonth().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })) + 1}`).slice(-2);
    const dayOfMonth = (`0${dateJs.getDate().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    return `${dayOfMonth}/${month}`;
  };

  const phaseLabel = () => {
    if (grandPrixRow.get('trackStatus')) {
      const trackStatus = grandPrixRow.get('trackStatus');
      if (isOtherPhase(trackStatus)) {
        return dictionary.competitionTable.gpStatus[trackStatus];
      }
    }
    return formatDate(grandPrixRow.get('date'));
  };

  const eventLabel = () => {
    const isCarMotorsport = window.matchcenterPage.sportId === '6C';
    const eventName = grandPrixRow.get('eventName') ? grandPrixRow.get('eventName').split(' GP')[0] : grandPrixRow.get('grandPrixCountry');
    const gpCountry = grandPrixRow.get('grandPrixCountry');
    if (!isCarMotorsport) return (dictionary.competitionTable.gpName[gpCountry] ? dictionary.competitionTable.gpName[gpCountry] : gpCountry);
    return dictionary.competitionTable.gpName[eventName] || eventName;
  };

  const circuitsUrl = ConfigManager.getMotorCircuit();
  const cleanNationName = name => (name.replace(/ /g, '_').toLowerCase());
  const winnerName = () => {
    if (window.matchcenterPage.competitionId !== 2 && grandPrixRow.has('winner1')) {
      return `${(grandPrixRow.getIn(['winner1', 'driverFirstName'])).charAt(0)}.${grandPrixRow.getIn(['winner1', 'driverLastName'])}`;
    }
    if (grandPrixRow.has('winner1') && grandPrixRow.has('winner2')) {
      return `${(grandPrixRow.getIn(['winner1', 'driverFirstName'])).charAt(0)}.${grandPrixRow.getIn(['winner1', 'driverLastName'])} - 
      ${(grandPrixRow.getIn(['winner2', 'driverFirstName'])).charAt(0)}.${grandPrixRow.getIn(['winner2', 'driverLastName'])}`;
    }
    return '-';
  };
  const isAbortedRace = grandPrixRow.get('trackStatus') === 'ABORTED';
  if (grandPrixRow.get('raceTrack') !== 'TBC') {
    return (
      <MotorSportRowWrapper
        href={!isAbortedRace ? prettyMatchUrl(grandPrixRow.get('raceTrack').toLowerCase(), '', grandPrixRow.get('matchId'), window.matchcenterPage.sportId, window.matchcenterPage.competitionId, process.env.REACT_APP_SITE) : undefined}
      >
        {grandPrixRow &&
          <Row style={{
            width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
          }}
          >
            <Col lg={1.5} md={2.5} sm={2} style={{ padding: '0' }}>
              <Label
                label={phaseLabel()}
                color={grandPrixRow.get('trackStatus') === st.ON_TRACK ? 'liveColor' : 'black'}
              />
            </Col>
            {!isMobile &&
              <Col md={2} sm={1} style={{ padding: '0' }}>
                <RaceViewCircuit>
                  <Circuit
                    src={`${circuitsUrl}${dictionary.raceCompetitionLink[window.matchcenterPage.competitionId]}/${cleanNationName(grandPrixRow.get('raceTrack'))}.png`}
                    gpFlag
                  />
                </RaceViewCircuit>
              </Col>
            }
            <Col lg={2} md={3} sm={3} style={{ padding: '0' }}>
              <Label
                label={eventLabel()}
                color={grandPrixRow.get('trackStatus') === st.ON_TRACK ? 'liveColor' : 'black'}
              />
            </Col>
            {!isMobile &&
              <Col md={1} sm={1} style={{ padding: '0' }}>
                <Label
                  label={grandPrixRow.get('laps')}
                />
              </Col>
            }
            {!isMobile &&
              <Col md={2} sm={2} style={{ padding: '0' }}>
                <Label
                  label={grandPrixRow.get('raceLength') !== '0 KM' ? grandPrixRow.get('raceLength').slice(0, -2).replace('.', ',') : ''}
                />
              </Col>
            }
            <Col lg={3} md={6} sm={6} style={{ padding: '0' }}>
              <Label
                label={winnerName()}
                weight="bold"
              />
            </Col>
            <Col lg={0.5} md={0.5} sm={1} style={{ padding: '0' }}>
              {!isAbortedRace &&
                <IconFont
                  className="icon-matchcenter-right-arrow"
                  color="linkColor"
                  font={18}
                  weight="bold"
                  withCursor
                />
              }
            </Col>
          </Row>
        }
      </MotorSportRowWrapper>
    );
  } else {
    return (
      <MotorSportRowWrapper>
        {grandPrixRow &&
          <Row style={{
            width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
          }}
          >
            <Col lg={1.5} md={2.5} sm={2} style={{ padding: '0' }}>
              <Label
                label=""
                color={grandPrixRow.get('trackStatus') === st.ON_TRACK ? 'liveColor' : 'black'}
              />
            </Col>
            {!isMobile &&
              <Col md={2} sm={1} style={{ padding: '0' }} />
            }
            <Col lg={2} md={3} sm={3} style={{ padding: '0' }}>
              <Label
                label="In Attesa di Conferma"
                color={grandPrixRow.get('trackStatus') === st.ON_TRACK ? 'liveColor' : 'black'}
              />
            </Col>
            {!isMobile &&
              <Col md={1} sm={1} style={{ padding: '0' }}>
                <Label
                  label=""
                />
              </Col>
            }
            {!isMobile &&
              <Col md={2} sm={2} style={{ padding: '0' }}>
                <Label
                  label=""
                />
              </Col>
            }
            <Col lg={3} md={6} sm={6} style={{ padding: '0' }}>
              <Label
                label={winnerName()}
                weight="bold"
              />
            </Col>
            <Col lg={0.5} md={0.5} sm={1} style={{ padding: '0' }} />
          </Row>
        }
      </MotorSportRowWrapper>
    );
  }
};

MotorSportRow.propTypes = {
  grandPrixRow: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
};

export default MotorSportRow;



// WEBPACK FOOTER //
// ./src/components/MotorSportRow/index.js